import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays } from "lucide-react";
import { SectionHeading, Reveal } from "@/components/Section";

export default function CalendarCTA() {
  return (
    <section id="calendar" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-20 sm:px-8 lg:px-12" data-testid="calendar-cta-section">
      <SectionHeading index="04" eyebrow="THIS WEEK · SUN–SAT" title="Games Calendar" />
      <Reveal>
        <Link
          to="/calendar"
          data-testid="view-full-calendar-link"
          className="group flex flex-col items-start gap-5 rounded-xl border border-bline bg-surface p-8 transition-all duration-200 hover:-translate-y-0.5 hover:border-volt/50 sm:flex-row sm:items-center"
        >
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-sm bg-volt/10">
            <CalendarDays className="h-7 w-7 text-volt" />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block font-display text-2xl tracking-wide text-white transition-colors group-hover:text-volt">
              THE FULL WEEK, TEAM BY TEAM
            </span>
            <span className="mt-1 block text-sm leading-relaxed text-slate-400">
              Every kickoff, first pitch and tip-off for all 31 DFW squads — TV networks, live badges and countdowns, week by week.
            </span>
          </span>
          <span className="flex shrink-0 items-center gap-2 font-display text-lg tracking-widest text-volt">
            OPEN CALENDAR
            <ArrowRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" />
          </span>
        </Link>
      </Reveal>
    </section>
  );
}
